"use strict";

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import Utils from '../Utils.jsx';
import PigNormal from '../../../Content/img/criticalillness/CriticalIllnessPigNormal.gif';
import PigWorried from '../../../Content/img/criticalillness/CriticalIllnessPigWorried.gif';
import PigPanicked from '../../../Content/img/criticalillness/CriticalIllnessPigPanicked.gif';

class CriticalIllnessExpenseCalcBottomFloater extends React.Component {
	constructor(props) {
		super(props);

	}

	render() {

		var worriedThreshold = this.props.Worried_Threshold;
		var surplusDeficit = this.props.Surplus_Deficit;
		var totalExpenses = this.props.Total_Expenses;
		var showFloater = this.props.Show;
		var whichpig;
		var { dollarResult, ouchOrPhewClass } = "";

		var imgStyle = {
			width: '95%'
		};

		dollarResult = Utils.formatDisplayRange(Math.abs(totalExpenses), "number");
		whichpig = <img src={PigWorried} className="ci-pig ci-pigworried" />;
		ouchOrPhewClass = "ci-short";

		if (surplusDeficit < worriedThreshold) {
			whichpig = <img src={PigPanicked} className="ci-pig ci-pigpanicked" />;
			ouchOrPhewClass = "ci-short ci-panic";
		}
		
		return <div className={"ci-summary-floater " + showFloater + " " + ouchOrPhewClass} >

			<div className="ci-pigblocksm">
				{whichpig}
			</div>
			<div className="ci-results">
				<div className="ci-dollaramt">${dollarResult} </div>
				<div className="ci-expenses">
					<div className="ci-total">Total</div>
					<div>Expenses</div>
				</div>
			</div>
			<div className="ci-cta">
				<div className="ci-cta-actionbtntray">
					<a href="https://www.bluecross.ca/life/?utm_source=pacific_blue_cross" className="ui button primary btn btn-primary ci-cta-actionbtn" id="ip-cii-expensecalculatorpage-triggar-get-a-quote-floating-banner" >Get a Quote</a>
				</div>
			</div>
		</div>


	}
}

CriticalIllnessExpenseCalcBottomFloater.propTypes = {
	Worried_Threshold: PropTypes.number,
	Surplus_Deficit: PropTypes.number,
	Total_Expenses: PropTypes.number,
	Show: PropTypes.string	
}

export default CriticalIllnessExpenseCalcBottomFloater;